"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "m12 1.991-.719.94-.004.005-.012.015-.043.058-.163.217a64.054 64.054 0 0 0-2.33 3.336c-.636.98-1.285 2.05-1.777 3.037-.247.493-.462.98-.616 1.433-.151.442-.265.908-.265 1.343 0 2.969 2.81 5.117 5.929 5.117s5.929-2.148 5.929-5.117c0-.435-.114-.9-.265-1.343-.155-.453-.37-.94-.616-1.433-.492-.987-1.14-2.058-1.777-3.037a63.999 63.999 0 0 0-2.493-3.553l-.043-.058-.012-.015-.004-.006L12 1.991Zm-.052 3.081.052-.07.052.07a62.342 62.342 0 0 1 1.701 2.476c.62.953 1.227 1.96 1.677 2.86.224.45.402.857.522 1.209.124.362.167.61.167.758 0 .613-.224 1.219-.626 1.74.007-.08.01-.162.01-.245a2.64 2.64 0 0 0-.16-.835 6.563 6.563 0 0 0-.341-.795c-.266-.531-.61-1.101-.944-1.614a33.456 33.456 0 0 0-1.307-1.863l-.023-.03-.007-.009-.002-.003L12 7.78l-.719.94-.002.003-.007.008-.023.031a27.58 27.58 0 0 0-.389.527 33.6 33.6 0 0 0-.918 1.336 17.164 17.164 0 0 0-.944 1.614 6.569 6.569 0 0 0-.34.795 2.64 2.64 0 0 0-.161.835c0 .084.003.165.01.246-.402-.522-.626-1.128-.626-1.741 0-.147.043-.396.167-.758.12-.352.298-.76.522-1.21.45-.899 1.057-1.906 1.677-2.86a62.245 62.245 0 0 1 1.701-2.475Zm-.667 3.649.719.55-.719-.55Zm.719.55.719-.55-.719.55Zm-.54 2.341c.185-.284.37-.557.54-.8.17.243.355.516.54.8.317.487.621.992.843 1.436.11.222.194.415.247.572.027.077.044.14.053.186.01.042.01.062.01.064 0 .562-.602 1.275-1.693 1.275-1.091 0-1.694-.713-1.694-1.274 0-.003.002-.023.01-.065a1.63 1.63 0 0 1 .054-.186c.053-.157.136-.35.247-.572.222-.444.526-.949.842-1.436ZM8.582 19.77v-1.81h6.834v1.81H8.583Zm-2.713.43v1.81h12.26V20.2H5.87Z", clipRule: "evenodd" }))); };
var SvgGas = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgGas');
exports.default = SvgGas;
